import store from '@/store'
import config from '@/config/nimConfig'
import Vue from 'vue'

// 用于demo记录封面
export function initChatroomInfos ({state, commit}, obj) {
  commit('initChatroomInfos', obj)
}
// 获取聊天室信息
export function getChatroomInfo ({state, commit, dispatch}, props={}) {
  let { getMember } = props;
  const chatroom = window ? window.chatroom : null
  if(!chatroom){
    return
  }
  if (chatroom) {
    chatroom.getChatroom({
      done: (error, info) => {
        if (error) {
          alert(error.message)
          return
        }
        info = info.chatroom || {creator: ''}
        let creator = info.creator
        chatroom.getChatroomMembersInfo({
          accounts: [creator],
          done:  (error, user) => {
            if (error) {
              alert(error.message)
              return
            }
            // 提交聊天室信息
            commit('setChatroomInfo', Object.assign(info,  {actor: user.members[0]}))

            //获取聊天室成员列表
            // if(getMember){
            //   dispatch('getChatroomMembers')
            // }
          }
        })
      }
    })
  }
}

export function getChatroomMembers ({state, commit, dispatch}) {
  // 先拉管理员
  getChatroomMembersLocal (false, (obj) => {
    commit('updateChatroomMembers', Object.assign(obj, {type: 'put'}))
    // 再拉成员列表
    getChatroomMembersLocal (true, (obj) => {
      commit('updateChatroomMembers', Object.assign(obj, {type: 'put'}))
    })
  })
}
// 获取聊天室成员
function getChatroomMembersLocal (isGuest, callback) {
  const chatroom = window ? window.chatroom : null
  if (chatroom) {
    chatroom.getChatroomMembers({
      guest: isGuest, // true表示获取游客, false表示获取非游客成员
      limit: 100,
      onlyOnline: true, //是否只获取在线的固定用户
      done: function getChatroomMembersDone (error, obj) {
        if (error) {
          alert(error.message)
          return
        }
        callback(obj)
      }
    })
  }
}

export function clearChatroomMembers ({state, commit}) {
  commit('updateChatroomMembers', {type: 'destroy'})
}

// 踢人
export function kickChatroomMember ({state, commit}, account) {
  // commit('updateChatroomMembers', {type: 'destroy'})
  const chatroom = window ? window.chatroom : null
  if (chatroom) {
    chatroom.kickChatroomMember({
      account: account, //踢出的人
      done: (error, obj) => {
        if (error) {
          console.log('踢人=>>',error.message)
          return
        }
        callback(obj)
      }
    })
  }
}
// 更新禁言状态
export function updateMemberMuted ({state, commit}, props) {
  const chatroom = window ? window.chatroom : null
  let { account, type } = props
  if (chatroom) {
    let _this = this
    chatroom.markChatroomGaglist({
      account: account.account,
      isAdd: type === 'add',
      done: (error, obj)=>{
        if(error){
          console.log(error.message);
          return
        }
        commit('updateChatroomMutedMembers', {
          account: account.account,
          tempMuted: type === 'add'
        })
      }
    });
  }
}
// 获取我的信息
export function getCurrMyChatroomInfo ({state, commit, dispatch}, props) {
  let { chatroomId, account } = props
  const chatroom = window ? window.chatroom : null
  if(!chatroom){
    return
  }
  chatroom.getChatroomMembersInfo({
    accounts: [account],
    done: (error, obj)=>{
      if(!error){
        let item = obj.members[0]
        if(item){
          item.custom = item.custom ? JSON.parse(item.custom) : {}
          commit('updateNimState', {
            state: 'currMyChatroomInfo',
            value: item
          })
        }
      }
    }
  });
}





